import datapointReducer from './reducers';

export default datapointReducer;
